import { Button, Col, Divider, Form, Image, Input, Row, Select } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";

import { addNews, editNews, getNewsbyId, uploadImage } from "./NewsApi";
import { ImSpinner10 } from "react-icons/im";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { JsonEditor } from "json-edit-react";

function AddNews() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [contentData, setContentData] = useState({});
  // const [imageURL, setImageURL] = useState(from === "add" ? "" : fill.image);
  const [isLoading, setIsLoading] = useState(false);
  // const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  // const [dashboardNewsImageURL, setDashboardNewsImageURL] = useState(from === "add" ? "" : contentData?.homePage);
  const [dashboardNewsImageURL, setDashboardNewsImageURL] = useState(
    from === "add" ? "" : fill?.homePage
  );
  const [dashboardNewsImageUploading, setDashboardNewsImageUploading] =
    useState(false);
  // const [newsSectionImageURL, setNewsSectionImageURL] = useState(from === "add" ? "" : contentData?.inner);
  const [newsSectionImageURL, setNewsSectionImageURL] = useState(
    from === "add" ? "" : fill?.inner
  );
  const [newsSectionImageUploading, setNewsSectionImageUploading] =
    useState(false);
  const [newsPageImageURL, setNewsPageImageURL] = useState(
    from === "add" ? "" : fill?.image
  );
  // const [newsPageImageURL, setNewsPageImageURL] = useState(from === "add" ? "" : contentData?.image);
  const [newsPageImageUploading, setNewsPageImageUploading] = useState(false);
  const [errorInJson, setErrorInJson] = useState(false);
  const { Option } = Select;

  // const handleFileUpload = useCallback(
  const handleDashboardNewsImageUpload = useCallback(
    async (e) => {
      try {
        // setUploading(true);
        setDashboardNewsImageUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        // setImageURL(url);
        setDashboardNewsImageURL(url);
        // setContentData({ ...contentData, image: url });
        setContentData({ ...contentData, homePage: url });
        // setUploading(false);
        setDashboardNewsImageUploading(false);
      } catch (error) {
        // setUploading(false);
        setDashboardNewsImageUploading(false);
        console.log({ error });
      }
    },
    [contentData]
  );

  const handleNewsSectionImageUpload = useCallback(
    async (e) => {
      try {
        setNewsSectionImageUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setNewsSectionImageURL(url);
        setContentData({ ...contentData, inner: url });
        setNewsSectionImageUploading(false);
      } catch (error) {
        setNewsSectionImageUploading(false);
        console.log({ error });
      }
    },
    [contentData]
  );

  const handleNewsPageImageUpload = useCallback(
    async (e) => {
      try {
        setNewsPageImageUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setNewsPageImageURL(url);
        setContentData({ ...contentData, image: url });
        setNewsPageImageUploading(false);
      } catch (error) {
        setNewsPageImageUploading(false);
        console.log({ error });
      }
    },
    [contentData]
  );

  function fetchNewsDataByID() {
    getNewsbyId(`${fill?.id}`)
      .then((response) => {
        if (response?.success) {
          setContentData(response?.data?.news);
          form.setFieldsValue(response?.data?.news);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  useEffect(() => {
    from === "edit" && fetchNewsDataByID();
  }, [form]);

  const AddNewsData = (values) => {
    const payload = {
      title: values.title,
      slug: values.slug,
      leagueName: values.leagueName,
      rank: values.rank,
      sport: values.sport,
      redirectLink: values.redirectLink,
      isActive: values.isActive,
      paragraph: values.paragraph,
      isIndexed: values.isIndexed,
      sitemap: contentData?.sitemap,
      // sitemap: values?.sitemap,
      meta: values.meta,
      faqs: values.faqs,
      rteString: values.rteString,
      // image: imageURL,
      homePage: dashboardNewsImageURL,
      inner: newsSectionImageURL,
      image: newsPageImageURL,
    };

    setIsLoading(true);

    addNews(payload)
      .then((response) => {
        // if (response.status) {
        if (response?.success) {
          navigate("/get/news_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const updateNewsData = (values) => {
    // console.log(values);
    // const payload = {
    //   redirectLink: values.redirectLink,
    //   isActive: values.isActive,
    //   rank: values.rank,
    //   image: imageURL,
    //   title: values.title,
    //   bonus: values.bonus,
    //   type: values.type,
    // };
    if (errorInJson) return;

    const payload = {
      title: values.title,
      slug: values.slug,
      leagueName: values.leagueName,
      rank: values.rank,
      sport: values.sport,
      redirectLink: values.redirectLink,
      isActive: values.isActive,
      paragraph: values.paragraph,
      isIndexed: values.isIndexed,
      sitemap: contentData?.sitemap,
      // sitemap: values?.sitemap,
      meta: values.meta,
      faqs: values.faqs,
      rteString: values.rteString,
      // image: imageURL,
      homePage: dashboardNewsImageURL,
      inner: newsSectionImageURL,
      image: newsPageImageURL,
    };

    setIsLoading(true);

    editNews(payload, `${fill?.id}`)
      .then((response) => {
        if (response?.success) {
          navigate("/get/news_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  //   useEffect(() => {
  //     if (fill) {
  //       form.setFieldsValue({
  //         title: fill.title,
  //         slug: fill.slug,
  //         amount: fill.amount,
  //         type: fill.type,
  //         rank: fill.rank,
  //         redirectLink: fill.redirectLink,
  //         isActive: fill.isActive,
  //         image: fill.image,
  //       });
  //     }
  //   }, [form, fill]);

  const metaTagOptions = [
    "description",
    "title",
    "keywords",
    "robots",
    "author",
  ];

  return (
    <div>
      <Divider
        orientation="left"
        style={{ border: "#cecece" }}
        className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
      >
        {from === "edit" ? "Update" : "Add"} News
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) =>
          from === "add" ? AddNewsData(values) : updateNewsData(values)
        }
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <Col>
            <Form.Item
              // label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Title</p>}
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Title/Page Keyword
                </p>
              }
              name="title"
              rules={[
                { required: true, message: "Please enter Title" },
                { message: "Title must be at least 4 characters" },
              ]}
            >
              {/* <Input placeholder="Title" /> */}
              <Input placeholder="Title/Page Keyword" />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Slug
                </p>
              }
              name="slug"
              rules={[
                { required: true, message: "Please enter Slug" },
                { message: "Slug must be at least 6 characters" },
              ]}
            >
              <Input placeholder="Slug" />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  League Name
                </p>
              }
              name="leagueName"
              rules={
                [
                  // { required: true, message: "Please enter League Name" },
                  // { min: 6, message: "League Name must be at least 6 characters" },
                  // { message: "League Name must be at least 6 characters" },
                ]
              }
            >
              <Input placeholder="League Name" />
            </Form.Item>
          </Col>

          {/* <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Rank</p>}
              name="rank"
              rules={[
                { required: true, message: "Please enter Email" },
                { message: "Rank is required" },
              ]}
            >
              <Input placeholder="Rank" />
            </Form.Item>
          </Col> */}

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Rank
                </p>
              }
              name="rank"
              rules={[
                // { required: true, message: "Please enter Rank" },
                {
                  required: true,
                  message: "Rank is required and should be greater then 0",
                },
                // { message: "Rank is required" },
              ]}
            >
              <Input placeholder="Rank" type="number" />
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          {/* <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Sport</p>}
              name="sport"
              rules={[
                { required: true, message: "Please enter Sport" },
                { message: "Sport is required" },
              ]}
            >
              <Input placeholder="Sport" />
            </Form.Item>
          </Col> */}

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Sport
                </p>
              }
              name="sport"
              // rules={[{ required: true, message: "Please select an option" }]}
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="Sport"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "American Football", value: "American Football" },
                  { label: "Baseball", value: "Baseball" },
                  { label: "Basketball", value: "Basketball" },
                  { label: "Boxing", value: "Boxing" },
                  { label: "Cricket", value: "Cricket" },
                  { label: "Football", value: "Football" },
                  { label: "Ice Hockey", value: "Ice Hockey" },
                  { label: "MMA", value: "MMA" },
                  { label: "Motor Racing", value: "Motor Racing" },
                  { label: "Rugby", value: "Rugby" },
                  { label: "Tennis", value: "Tennis" },
                  { label: "Sports Betting", value: "Sports Betting" },
                  { label: "Crypto Casino", value: "Crypto Casino" }
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Redirect Link
                </p>
              }
              name="redirectLink"
            >
              <Input placeholder="Redirect Link" />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Active Status
                </p>
              }
              name="isActive"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Description
                </p>
              }
              name="paragraph"
              rules={[
                { required: true, message: "Please enter Description" },
                { message: "Description is required" },
              ]}
            >
              <Input placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Index Page
                </p>
              }
              name="isIndexed"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            <JsonEditor
              data={
                contentData?.sitemap ? JSON.parse(contentData?.sitemap) : {}
              }
              setData={(v) => {
                // console.log("json was set ");
                setContentData({ ...contentData, sitemap: JSON.stringify(v) });
                setErrorInJson(false);
              }}
              onError={(e) => setErrorInJson(true)}
            />
          </Col>
        </Row>

        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
            Meta Tags
          </p>
          <Col>
            <Form.Item
              validateTrigger="onSubmit"
              style={{ marginBottom: "16px" }}
            >
              <Form.List
                name="meta"
                rules={[
                  {
                    validator: async (_, metaTags) => {
                      if (!metaTags || metaTags.length < 1) {
                        return Promise.reject(
                          new Error("Please add at least one tag")
                        );
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }, index) => {
                        const availableTags = metaTagOptions;

                        return (
                          <div
                            key={key}
                            style={{ marginBottom: "16px" }}
                            className="grid grid-cols-1 sm:grid-cols-[1%_47%_40%_8%] gap-4"
                          >
                            <p className="font-medium">{index + 1}.</p>

                            <Form.Item
                              {...restField}
                              name={[name, "name"]}
                              fieldKey={[fieldKey, "name"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a meta tag name",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select a tag"
                                suffixIcon={
                                  <Image
                                    src={`${dropDownImage}`}
                                    preview={false}
                                  />
                                }
                              >
                                {availableTags.slice(0, 5).map((option) => (
                                  <Option key={option} value={option}>
                                    {option.charAt(0).toUpperCase() +
                                      option.slice(1)}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "content"]}
                              fieldKey={[fieldKey, "content"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter meta tag content",
                                },
                              ]}
                            >
                              <Input.TextArea placeholder="e.g.,Discover New Courses and Ideas" />
                            </Form.Item>

                            <Button
                              onClick={() => remove(name)}
                              className="remove-button NoButtonHover "
                            >
                              Remove
                            </Button>
                          </div>
                        );
                      }
                    )}

                    <Form.Item>
                      <Button
                        className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Meta Tag
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
            FAQs
          </p>
          <Col>
            <Form.Item
              validateTrigger="onSubmit"
              style={{ marginBottom: "16px" }}
            >
              <Form.List name="faqs">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }, index) => {
                        return (
                          <div
                            key={key}
                            style={{ marginBottom: "16px" }}
                            className="grid grid-cols-1 sm:grid-cols-[1%_47%_40%_8%] gap-4"
                          >
                            <p className="font-medium">{index + 1}.</p>

                            <Form.Item
                              {...restField}
                              name={[name, "q"]}
                              fieldKey={[fieldKey, "q"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter a question",
                                },
                              ]}
                            >
                              <Input.TextArea placeholder="e.g.,Frequently asked question" />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "a"]}
                              fieldKey={[fieldKey, "a"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter answer",
                                },
                              ]}
                            >
                              <Input.TextArea placeholder="e.g.,Discover New Courses and Ideas" />
                            </Form.Item>

                            <Button
                              onClick={() => remove(name)}
                              className="remove-button NoButtonHover "
                            >
                              Remove
                            </Button>
                          </div>
                        );
                      }
                    )}

                    <Form.Item>
                      <Button
                        className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add FAQ
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 gap-4 mb-16">
          <Form.Item label="Content" name="rteString">
            <ReactQuill form={form} name="rteString" />
          </Form.Item>
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
              // name="image"
              // name="dashboardNewsImage"
              name="homePage"
              // label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">News Image</p>}
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Dashboard News Image (Aspect Ratio must be 4/3)
                </p>
              }
              rules={[
                { required: true, message: "Dashboard News Image is required" },
              ]}
            >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {/* {uploading ? ( */}
                {dashboardNewsImageUploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : // ) : imageURL ? (
                //   <Image src={imageURL} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                // ) : contentData?.image ? (
                //   <Image src={contentData?.image} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                contentData?.homePage ? (
                  <Image
                    src={contentData?.homePage}
                    height={127}
                    width={127}
                    className="rounded-sm object-cover"
                    preview={false}
                  />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                {/* <input type="file" name="photo" id="upload-photo" onChange={handleFileUpload} /> */}
                <input
                  type="file"
                  name="photo"
                  id="upload-dashboard-news-image"
                  onChange={handleDashboardNewsImageUpload}
                />
                {/* <label for="upload-photo" className="cursor-pointer"> */}
                <label
                  for="upload-dashboard-news-image"
                  className="cursor-pointer"
                >
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
                {/* <button >Replace</button> */}
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
              // name="newsSectionImage"
              name="inner"
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  News Section Image (Aspect ratio must be 9/5)
                </p>
              }
              rules={[
                { required: true, message: "News Section Image is required" },
              ]}
            >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {newsSectionImageUploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : contentData?.inner ? (
                  <Image
                    src={contentData?.inner}
                    height={127}
                    width={127}
                    className="rounded-sm object-cover"
                    preview={false}
                  />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                <input
                  type="file"
                  name="photo"
                  id="upload-news-section-image"
                  onChange={handleNewsSectionImageUpload}
                />
                <label
                  for="upload-news-section-image"
                  className="cursor-pointer"
                >
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
              // name="newsPageImage"
              name="image"
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  News Page Image (Aspect Ratio must be 2/1)
                </p>
              }
              rules={[
                { required: true, message: "News Page Image is required" },
              ]}
            >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {newsPageImageUploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : contentData?.image ? (
                  <Image
                    src={contentData?.image}
                    height={127}
                    width={127}
                    className="rounded-sm object-cover"
                    preview={false}
                  />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                <input
                  type="file"
                  name="photo"
                  id="upload-news-page-image"
                  onChange={handleNewsPageImageUpload}
                />
                <label for="upload-news-page-image" className="cursor-pointer">
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                navigate("/get/news_details");
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            {/* <Button className="NoButtonHover create-button" size="small" htmlType="submit" loading={isLoading} disabled={uploading}> */}
            <Button
              className="NoButtonHover create-button"
              size="small"
              htmlType="submit"
              loading={isLoading}
              disabled={
                dashboardNewsImageUploading ||
                newsSectionImageUploading ||
                newsPageImageUploading
              }
            >
              {from === "edit" ? "Update" : "Add"} News
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default AddNews;
